<script>
import { mapActions } from 'vuex'

const commonRules = {
  'required-field': {
    required: true,
    message: 'To pole jest wymagane.',
    trigger: 'blur'
  },
  'password-rules': {
    pattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})',
    message: 'Hasło musi zawierać co najmniej jedną: dużą, małą literę i cyfrę oraz minimum 8 znaków.'
  }
}

export default {
  name: 'password-reset',
  data () {
    let validatePassword = (rule, value, callback) => {
      if (this.newPasswordForm.passwordAgain !== '') {
        this.$refs.newPasswordForm.validateField('passwordAgain')
      }
      callback()
    }
    let validatePasswordAgain = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('To pole jest wymagane.'))
      } else if (value !== this.newPasswordForm.password) {
        callback(new Error('Wprowadzone hasła są różne.'))
      } else {
        callback()
      }
    }
    return {
      newPasswordForm: {
        password: null,
        passwordAgain: null
      },
      rules: {
        password: [
          commonRules[ 'required-field' ],
          commonRules[ 'password-rules' ],
          { validator: validatePassword }
        ],
        passwordAgain: [
          commonRules[ 'required-field' ],
          { validator: validatePasswordAgain }
        ]
      }
    }
  },
  computed: {},
  created () {
    console.log(this.$route.params)
  },
  methods: {
    ...mapActions([
      'aUserAccountPasswordReset'
    ]),
    handlePasswordReset: function (formName) {
      this.$refs[ formName ].validate((valid, validated) => {
        if (valid) {
          this.aUserAccountPasswordReset({
            password: this[ formName ].password,
            code: this.$route.params.code
          })
        }
        return false
      })
    }
  }
}
</script>

<template>
  <div>
    <el-row :gutter="20">
      <el-col
        :span="12"
        :offset="6"
      >
        <el-form
          ref="newPasswordForm"
          label-width="120px"
          size="small"
          status-icon
          :model="newPasswordForm"
          :rules="rules"
        >
          <el-card class="box-card">
            <el-form-item
              label="hasło"
              prop="password"
            >
              <el-input
                placeholder="wprowadź nowe hasło"
                type="password"
                v-model="newPasswordForm.password"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="powtórz hasło"
              prop="passwordAgain"
            >
              <el-input
                placeholder="wprowadź ponownie hasło"
                type="password"
                v-model="newPasswordForm.passwordAgain"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="handlePasswordReset('newPasswordForm')"
              >Ustaw nowe hasło</el-button>
            </el-form-item>
          </el-card>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/user-account/password-reset.vue